export const getNameInitials = (fullName: string) => {
  const names = fullName.trim().split(' ')
  const [firstName] = names
  const lastName = names[names.length - 1]

  return (firstName[0] + lastName[0]).toUpperCase()
}
